import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PageHeaderBreadcrumb {
  label: string;
  route?: string;
  navigate?: () => void;
}

export interface PageHeaderState {
  breadcrumbs: PageHeaderBreadcrumb[];
  title: string;
  showBack: boolean;
  onBack?: () => void;
}

const EMPTY_PAGE_HEADER_STATE: PageHeaderState = {
  breadcrumbs: [],
  title: '',
  showBack: false
};

@Injectable()
export class PageHeaderService {
  private readonly pageHeaderSubject = new BehaviorSubject<PageHeaderState>(EMPTY_PAGE_HEADER_STATE);

  readonly pageHeader$ = this.pageHeaderSubject.asObservable();

  setFromPage(state: PageHeaderState): void {
    this.pageHeaderSubject.next(state);
  }

  clear(): void {
    this.pageHeaderSubject.next(EMPTY_PAGE_HEADER_STATE);
  }
}
